export default __webpack_public_path__ + "static/6-e9a94128a27c90f2639b52e7b0fa14db.png";